import axios from 'axios';

// URL da API com protocolo HTTPS
const API_URL = 'https://padronizador.cartoriocriciumasc.com.br/api';
console.log('Configurando API com URL:', API_URL);

// Cria uma instância do axios com a URL base da API
const api = axios.create({
  baseURL: API_URL,
  timeout: 10000, // 10 segundos de timeout
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  }
});

// Função para adicionar um parâmetro de timestamp para evitar cache
const addTimestampToURL = (url) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}_t=${new Date().getTime()}`;
};

// Configuração dos interceptadores de requisição
api.interceptors.request.use(
  (config) => {
    // Para requisições GET, adicionar um timestamp para evitar cache
    if (config.method === 'get') {
      config.url = addTimestampToURL(config.url);
    }
    
    console.log(`Requisição [${config.method.toUpperCase()}] para ${config.url}`);
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Erro na configuração da requisição:', error);
    return Promise.reject(error);
  }
);

// Configuração dos interceptadores de resposta
api.interceptors.response.use(
  (response) => {
    console.log(`Resposta [${response.status}] de ${response.config.url}`);
    return response;
  },
  (error) => {
    // Criar mensagem de erro mais detalhada
    const errorMsg = error.response 
      ? `Erro ${error.response.status} em ${error.config.url}: ${error.response.data?.erro || 'Erro desconhecido'}`
      : `Erro de rede em ${error.config?.url || 'URL desconhecida'}: ${error.message}`;
    
    console.error(errorMsg, error);
    
    if (error.response && error.response.status === 401) {
      // Limpar dados da sessão quando o token expirar
      console.log('Token expirado ou inválido. Redirecionando para login...');
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      // Redirecionar para a página de login se necessário
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api; 